<template>
  <div>
    <Add_employee/>
  </div>
</template>

<script>
import Add_employee from "@/components/adminArin/admin_overall/Add_employee";
export default {
  name: "AddEmployee",
  components: {
    Add_employee
  }
}
</script>

<style scoped>

</style>
